import { UploadMultiFiles } from "src/app/libs/uploadMultiFiles";
import { AnalyzedBrief, ApiResponse } from "src/types";
import {
  MAX_SIZE_SINGLE_ATTACHMENT,
  ParentType,
} from "src/utils/uploadFunctionsUtils";
import { API_URLS } from "src/utils/API_URLS";
import { handleError } from "src/utils/error";

const SUPPORTED_FILE_TYPES = ["pdf", "docx", "txt"];

const uploadContentGuidelinesFile = async ({
  file,
  wsMetaFieldUuid,
  wsProjectUuid,
  wsWorkspaceUuid,
}: {
  file: File;
  wsMetaFieldUuid: string;
  wsProjectUuid: string;
  wsWorkspaceUuid: string;
}): Promise<AnalyzedBrief | undefined> => {
  const uploadFile = new UploadMultiFiles({
    files: [file],
    allowedTypes: SUPPORTED_FILE_TYPES,
    maxSize: MAX_SIZE_SINGLE_ATTACHMENT,
    presignedUploadRequestUrl: API_URLS.presignedRequestForProjectMetaField,
    parentType: ParentType.wsProjectMetaField,
    parentUuid: wsMetaFieldUuid,
    wsWorkspaceUuid,
    wsProjectUuid,
    createAssetsUrl: API_URLS.createCreateAiContentGuidelines,
  });

  try {
    uploadFile.validate();
    const assets = await uploadFile.createDataStructureForAssets();

    const response =
      await uploadFile.createAssets<ApiResponse<AnalyzedBrief>>(assets);

    return response?.data.content;
  } catch (err) {
    handleError(err);
    console.error("uploadContentGuidelines error: ", err);
  }
};

export { uploadContentGuidelinesFile };
